import React from "react";
import Home from './Home';
import Process from './Process';
import Residential from './Residential';
import Commercial from "./Commercial";
import Products from './Products';
import Contact from './Contact';

const Wrapper = (props) => {

    return (
        <div class="container mt-4">

            {(() => {
                switch (props.display) {
                    case "home":
                        return <Home />
                    case 'process':
                        return <Process />
                    case "residential":
                        return <Residential />
                    case "commercial":
                        return <Commercial />
                    case "products":
                        return <Products />
                    case "contact":
                        return <Contact />
                }
            }
            )()}
        </div>
    )
};
export default Wrapper;